import { mapGetters } from 'vuex';
import { omitBy, isNil, filter } from 'lodash';

export default {
    props: {
        /**
         * Поля фильтра
         * @type {Object}
         */
        fields: {
            type: Object,
            default: () => {}
        },
        /**
         * Предустановленные значения фильтров
         * @type {Object}
         */
        settedValues: {
            type: [Object,Function],
            default: () => {}
        },
        /**
         * Доп. значения для фильтрация
         * @type {Object}
         */
        additionalValues: {
            type: Object,
            default: () => {}
        },
        /**
         * Модальное
         * 
         * @type {Boolean}
         */
        isModal: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['getNoImage', 'isDeviceDesktop']),
        filtersCount() {
            const filteredValues = filter(
                this.values,
                (f, key) => {
                    let exists = false;
                    if (Array.isArray(f) && f.length > 0 || !Array.isArray(f) && f) {
                        switch (key) {
                        case 'country':
                            exists = this.fields.countries;
                            break;
                        case 'arabic':
                            exists = false;
                            break;
                        default:
                            exists = true;
                            break;
                        }
                    }

                    return exists;
                }
            );

            return Object.keys(filteredValues).length;
        }
    },
    watch: {
        values: {
            handler(vals){
                if (!this.stopEvents.changed) {
                    this.$bus.$emit('CatalogFilter::changed', vals);
                    this.$emit('change', {
                        values: vals,
                        count: this.filtersCount
                    });
                }
            },
            deep: true
        }
    },
    created() {
        if (this.settedValues) {
            for (const key in this.settedValues) {
                if (this.settedValues[key]) {
                    this.values[key] = (this.settedValues[key] + '').split(',');
                }
            };
        }
    },
    mounted() {
        this.$nextTick(() => {this.stopEvents.changed = false;});
    },
    methods: {
        reset(id) {
            switch (id) {
            case 'country':
                if (this.fields.countries) {
                    this[id + 'Query'] = null;
                    this.values[id] = Array.isArray(this.values[id]) ? [] : null;
                }
                break;
            default:
                this.values[id] = Array.isArray(this.values[id]) ? [] : null;
                break;
            };
            
        },

        resetAll() {
            if (this.isDeviceDesktop && !this.isModal) {
                this.stopEvents.changed = true;
            }
            for (const key in this.values) {
                if (!key.includes('_')) {
                    this.reset(key);
                }
            }
            if (this.isDeviceDesktop) {
                this.$emit('reset');
                this.$refs.filter.hideCount();
                this.$nextTick(() => {this.stopEvents.changed = false;});
            }
        },

        countUrl() {
            const additional = omitBy(this.additionalValues, isNil);

            return this.$options.filters.urlRestQueryUrl(
                this.model.resource(), 
                {...this.values, ...additional, count_total: "y"}
            );
        }
    }
}